// YANKI · presentation · 3 testimonial kart · feature + 2 tile

import { useRef } from "react";
import { SectionShell } from "@/features/landing/components/SectionShell";
import { COPY } from "@/features/landing/content/landing-copy";
import { useYankiMotion } from "./Yanki.motion";
import styles from "./Yanki.module.css";

export function Yanki() {
  const scopeRef = useRef<HTMLElement | null>(null);
  useYankiMotion(scopeRef);

  return (
    <SectionShell id="yanki" ariaLabelledBy="yanki-title" tone="paper" container="wide">
      <div className={styles.yanki} ref={scopeRef as unknown as React.RefObject<HTMLDivElement>}>
        <header className={styles.yanki__head}>
          <p className={styles.yanki__eyebrow}>{COPY.yanki.chapter} · {COPY.yanki.eyebrow}</p>
          <h2 className={styles.yanki__title} id="yanki-title">{COPY.yanki.title}</h2>
          <p className={styles.yanki__caption}>{COPY.yanki.caption}</p>
        </header>

        <ol className={styles.yanki__grid} role="list" aria-label="Müşteri yorumları">
          {COPY.yanki.testimonials.map((t, i) => {
            const kindClass = styles[`tcard--${t.kind}`] || "";
            return (
              <li key={i} className={`${styles.tcard} ${kindClass}`.trim()}>
                <figure className={styles.tcard__inner}>
                  <div className={styles.tcard__image}>
                    <img
                      src={`/${t.src}`}
                      alt={t.alt}
                      width={t.kind === "feature" ? 1200 : 800}
                      height={t.kind === "feature" ? 800 : 600}
                      loading="eager"
                      decoding="async"
                    />
                    <span className={styles.tcard__sigil} aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
                        <path d="M3 12 L21 12 M12 3 L12 21" />
                      </svg>
                    </span>
                  </div>

                  <div className={styles.tcard__body}>
                    <svg className={styles.tcard__quote} viewBox="0 0 32 24" aria-hidden="true">
                      <text x="0" y="20" fontSize="32" fontWeight="600" fontFamily="serif" fill="currentColor">"</text>
                    </svg>
                    <blockquote className={styles.tcard__quoteText}>{t.quote}</blockquote>
                    <footer className={styles.tcard__attr}>
                      <span className={styles["tcard__attr-name"]}>{t.name}</span>
                      <span className={styles["tcard__attr-org"]}>{t.org} · {t.period}</span>
                    </footer>
                  </div>
                </figure>
              </li>
            );
          })}
        </ol>
      </div>
    </SectionShell>
  );
}
